module.exports = __webpack_public_path__ + "website/img/paas_02.559232a7.png";